<template>
  <el-dropdown class="sort-dropdown" :trigger="trigger">
    <slot name="menu-action"></slot>
    <el-dropdown-menu class="sort-dropdown-menu" slot="dropdown">
      <!--搜索标签-->
      <div
        class="sort-dropdown-menu__label"
        v-if="sortableList && sortableList.length"
      >
        SORT BY
      </div>
      <template>
        <!--排序-->
        <el-dropdown-item
          v-for="(sortItem, i) in sortableList"
          :key="'sort_' + i"
          class="sort-dropdown-menu__item"
        >
          <sortable-item
            :item="sortItem"
            @sort-by="sortBy => doSortby(sortItem.key, sortBy)"
          ></sortable-item>
        </el-dropdown-item>
        <!--动作-->
        <el-dropdown-item
          v-for="(actionItem, i) in actionList"
          :key="'action_' + i"
          :divided="!!sortableList.length && i === 0"
          class="sort-dropdown-menu__item"
        >
          <div @click="doAction(actionItem.key)">
            <i :class="actionItem.icon" class="sort-dropdown-menu__icon"></i>
            <span>{{ actionItem.name }}</span>
          </div>
        </el-dropdown-item>
      </template>
      <!--刷新-->
      <el-dropdown-item
        class="sort-dropdown-menu__item"
        :divided="showBottomDivided"
      >
        <div @click="doRefresh">
          <i class="el-icon-refresh sort-dropdown-menu__icon"></i>
          <span>Refresh List</span>
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import SortableItem from '@/components/sortable-item/index.vue'
import SortMenu from '@/entities/sort-menu'
/*!
 * 过滤/搜索弹出菜单
 */
export default {
  name: 'index',
  components: { SortableItem },
  props: {
    sortList: {
      type: Array,
      default: () => []
    },
    actionList: {
      type: Array,
      default: () => []
    },
    trigger: {
      type: String,
      default: 'click'
    }
  },
  computed: {
    sortableList() {
      return (this.sortList || []).filter(t => {
        return t.sortable
      })
    },
    showBottomDivided() {
      return (
        (!!this.sortableList && !!this.sortableList.length) ||
        (!!this.actionList && !!this.actionList.length)
      )
    }
  },
  methods: {
    doAction(actionKey) {
      this.$emit('action', actionKey)
    },
    doSortby(itemKey, sortBy) {
      this.$emit('sort', itemKey, sortBy)
    },
    doRefresh() {
      this.$emit('refresh')
    }
  }
}
</script>

<style scoped lang="scss">
.sort-dropdown {
  &-menu {
    width: 200px;
    padding: 0;

    &__label {
      color: #999;
      font-size: $font-size-small;
      text-transform: uppercase;
      padding: 14px 15px 5px;
      font-weight: 600;
    }

    &__item {
      display: block;
      width: 100%;
      padding: 0.25rem 1.5rem;
      clear: both;
      color: #212529;
      font-size: $font-size-small;
      text-align: inherit;
      background-color: transparent;
      text-transform: uppercase;
    }

    &__icon {
      font-size: $font-size-normal;
    }
  }
}
</style>
